import clsx from 'clsx'
import * as React from 'react'
import styles from './Vignette.module.scss'
import { useVignette, VignetteCornerProp, VignetteSize } from './useVignette'

interface VignetteProps {
  children: React.ReactNode
  className?: string
  size?: VignetteSize
  darkCorner?: VignetteCornerProp
  darkCornerSize?: VignetteSize
}

const Vignette: React.FC<VignetteProps> = ({
  children,
  className,
  size,
  darkCorner,
  darkCornerSize,
}) => {
  const {
    corner,
    size: vSize,
    darkCornerSize: cSize,
  } = useVignette({
    size,
    darkCorner,
    darkCornerSize,
  })

  return (
    <div
      className={clsx(
        styles.vignetteRoot,
        styles[`size-${vSize}`],
        styles[`corner-${cSize}`],
        styles[corner],
        className
      )}
    >
      {children}
    </div>
  )
}

export default Vignette
